<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">{{ $t('message.forgetPassword') }}</v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                  :label="$t('message.email')"
                  prepend-icon="mdi-email"
                  v-model="email"
                  type="email"
                  :rules="[rules.required, rules.email]"
              ></v-text-field>
              <v-btn color="primary" class="mt-4" block @click="sendResetLink">
                {{ $t('message.sendResetLink') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for success message -->
    <v-snackbar
        v-model="snackbarSuccess"
        color="success"
        top
        multi-line
        timeout="3000"
    >
      {{ successMessage }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar for error message -->
    <v-snackbar
        v-model="snackbarError"
        color="error"
        top
        multi-line
        timeout="3000"
    >
      {{ errorMessage }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbarError = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      snackbarSuccess: false,
      snackbarError: false,
      successMessage: '',
      errorMessage: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid.',
      },
    };
  },
  methods: {
    async sendResetLink() {
      // const axios = require('axios');
      let data = JSON.stringify({
        "email": this.email,
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: '/api/session/SendResetEmail/',
        data: data
      };

      try {
        await axios.request(config).then((res) => {
          console.log(JSON.stringify(res.data));
          this.successMessage = 'Reset email sent successfully! You will receive the email within approximately 3 minutes. Please check your inbox and spam folder.';
          this.snackbarSuccess = true;
          setTimeout(() => {
            this.$router.push('/login')
            }, 3000);
          // this.$router.push('/login')
        })
      } catch(err) {
        console.log(err);
        this.errorMessage = err.response?.data?.msg || 'We Can\'t Send Message To This E-Mail. Please try again.';
        this.snackbarError = true;
      }

      // axios.request(config)
      // .then((res) => {
      //   console.log(JSON.stringify(res.data));
      //   this.$router.push('/login')
      // })
      // .catch((err) => {
      //   console.log(err);
      // });
    }
  },
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
